import DSLink from './src'

export default DSLink
